import { State, TabDisplayInterface, UserRole } from '@wam/shared';
import { Injectable, OnDestroy, inject } from '@angular/core';
import { combineLatest, Observable, of, Subject } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { map, takeUntil } from 'rxjs/operators';
import { authenticationSelectors } from '@wam/authentication';
import { RosteringService } from '@app/teacher-users/rostering-data.service';

@Injectable({
  providedIn: 'root',
})
export class OrganizationsTabDisplayService implements TabDisplayInterface, OnDestroy {
  private store = inject<Store<State>>(Store);
  private readonly rosteringService = inject<RosteringService>(RosteringService);

  private destroyed$ = new Subject<void>();

  isFirst(): Observable<boolean> {
    return of(false);
  }

  shouldShow(): Observable<boolean> {
    return combineLatest([
      this.store.pipe(select(authenticationSelectors.getUserRoles)),
      this.rosteringService.applyEIRRestrictions(),
    ]).pipe(
      map(
        ([roles, applyRestrictions]: [UserRole[], boolean]) =>
          (roles?.includes(UserRole.DISTRICT_ADMIN) || roles?.includes(UserRole.SCHOOL_ADMIN)) &&
          !applyRestrictions,
      ),
      takeUntil(this.destroyed$),
    );
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
